import { createCrewLookupSelect } from './createCrewLookupSelect';

export const QuestionnaireKindSelect = createCrewLookupSelect(
  'QuestionnaireKindSelect',
  'questionnaireKinds',
);
export default QuestionnaireKindSelect;
